import React, { useState, useContext } from 'react';
import { PortfolioLightBox, PortfolioSection } from './portfolioStyle';
import Projects from '../projects/Projects';
import AgbaContext from '../../context/agba/agbaContext';

const ProjectItem = () => {
  const [state, setState] = useState(false);
  const [previewImg, setPreviewImg] = useState(null);

  const agbaContext = useContext(AgbaContext);
  const { projects, loading } = agbaContext;

  const lightBox = (project_img) => {
    if (state) {
      setState(false);
      setPreviewImg(null);
    } else {
      setState(true);
      setPreviewImg(project_img);
    }
  };
  const handleClose = () => {
    setState(false);
  };

  return (
    <>
      {state && (
        <PortfolioLightBox>
          <span className='close' onClick={handleClose}>
            &times;
          </span>
          <div className='navigation'>
            <img src={previewImg} alt='' className='modal-content' />
          </div>
        </PortfolioLightBox>
      )}
      <PortfolioSection>
        <div className='project-div'>
          {!loading &&
            projects.length &&
            projects.slice(0, 2).map((item, index) => {
              return (
                <Projects
                  layoutIndex={index + 1}
                  projectData={item.fields}
                  key={item.id}
                  lightBox={lightBox}
                />
              );
            })}
        </div>
      </PortfolioSection>
    </>
  );
};

export default ProjectItem;
